import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Wheat, Cake, UtensilsCrossed, Coffee } from 'lucide-react';
import { handleWhatsAppClick } from '@/lib/whatsapp.js';
import EditableField from './EditableField.jsx';
import WhatsAppIcon from './WhatsAppIcon.jsx';

const SEGMENT_ICONS = { Wheat, Cake, UtensilsCrossed, Coffee };

const SegmentCard = ({ section, fieldPrefix, icon, title, bgClass, problem, benefits, result, ctaText, id, delay = 0 }) => {
  const IconComponent = SEGMENT_ICONS[icon];
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay }}
      className={`rounded-2xl p-6 sm:p-8 flex flex-col h-full border border-border/50 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 w-full max-w-full overflow-hidden ${bgClass || 'bg-white'}`}
    >
      <div className="flex items-center gap-4 mb-6 w-full">
        <div className="bg-white/50 w-14 h-14 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center shadow-sm backdrop-blur-sm border border-border/50 flex-shrink-0">
          {IconComponent && <IconComponent className="w-7 h-7 text-primary" />}
        </div>
        <EditableField section={section} field={`${fieldPrefix}.title`} value={title} as="h3" className="font-heading text-xl sm:text-2xl font-bold text-foreground uppercase tracking-tight block flex-1 break-words leading-tight" />
      </div>
      
      <div className="mb-6 bg-muted/40 p-4 sm:p-5 rounded-xl text-sm font-medium text-foreground/80 border border-border/50 flex flex-col w-full">
        <span className="text-destructive font-bold mb-2 uppercase tracking-wide text-xs">O Desafio Comum:</span>
        <EditableField section={section} field={`${fieldPrefix}.problem`} value={problem} multiline className="break-words leading-relaxed" />
      </div>
      
      <ul className="space-y-3 mb-8 flex-grow w-full">
        {benefits?.map((benefit, i) => (
          <li key={i} className="flex items-start gap-3 w-full">
            <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
            <EditableField section={section} field={`${fieldPrefix}.benefits.${i}`} value={benefit} className="font-body text-sm font-medium text-foreground/90 block flex-1 break-words leading-relaxed" />
          </li>
        ))}
      </ul>
      
      <div className="mt-auto w-full">
        <div className="mb-6 border-l-4 border-primary pl-4 bg-primary/5 py-3 pr-3 rounded-r-xl w-full">
          <p className="font-body text-[10px] sm:text-xs uppercase tracking-wider text-muted-foreground font-bold mb-1">Resultado Comprovado</p>
          <EditableField section={section} field={`${fieldPrefix}.result`} value={result} as="p" className="font-heading font-bold text-base sm:text-lg text-primary block break-words leading-tight" />
        </div>
        
        <button 
          id={id}
          data-gtm="whatsapp"
          onClick={() => handleWhatsAppClick(`Olá Hiperpan! Tenho interesse na proposta customizada para: ${title}`)}
          className="gtm-whatsapp segment-button group text-sm uppercase tracking-wide w-full flex py-3 px-4"
        >
          <div className="segment-button-icon flex-shrink-0">
            <WhatsAppIcon className="w-5 h-5" />
          </div>
          <div className="segment-button-text flex-1 whitespace-normal break-words leading-tight px-2 text-center">
            <EditableField section={section} field={`${fieldPrefix}.ctaText`} value={ctaText} />
          </div>
          <div className="segment-button-icon flex-shrink-0">
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </div>
        </button>
      </div>
    </motion.div>
  );
};

export default SegmentCard;